import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import moment from "moment";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import Text from "../../../utils/Custom/text";
import CommonForm from "../../../utils/commonComponent/commonForm";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import { getPermissions } from "../rbac/hasAccess";
// import ProductDetails from "../../productDetails/productDetails";

const EditpoAcceptance = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [inputStates, setInputStates] = React.useState({});
  const [quotationList, setquotationList] = useState([]);

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const inputFields = [
    {
      type: "Autocomplete",
      label: "Quotation Number *",
      stateKey: "quotationId",
      options: quotationList,
      valueKey: "id",
      getOptionLabelKey: "quotationNumber",
      disabled: params.id != 0,
    },
    {
      type: "DatePicker",
      label: "Quotation Date",
      stateKey: "quotationDate",
      disabled: true,
    },
    { type: "TextField", label: "Po Number", stateKey: "poNumber" },
    { type: "DatePicker", label: "Po Date", stateKey: "poDate" },
    { type: "TextField", label: "Amount", stateKey: "amount" },
    { type: "ImageUpload", label: "Upload File", stateKey: "poFileUrl" },
  ];

  // const [productArray, setProductArray] = React.useState([]);
  // const [poFileUrl, setpoFileUrl] = useState("");
  const [poAacceptanceData, createPoAacceptance] = useState({});
  const [productReadingRows, setproductReadingRows] = React.useState([]);
  const [grandTotal, setGrandTotal] = React.useState(0);
  const [invoiceObject, updateInvoiceObject] = React.useState({
    subject: "Invoice for Calibration of Equipment",
    challanNo: "",
    challanDate: "",
    productDetails: "",
    totalAmount: "",
    clientId: "",
    quotationNumber: "",
    enquiryReference: "",
    invoiceDate: "",
    gstType: "",
    companyName: "",
    address: "",
    termsConditions: "",
    scopeservices: "",
    srfInstrumentIdsArray: [],
    discount: null,
    discountAmount: "",
  });

  const totalInstrumentQuantity = productReadingRows?.reduce(
    (total, product) => {
      return total + product.quantity;
    },
    0
  );

  const getquotationData = () => {
    let url = BASE_URL;
    let qtlistAll = {
      query: "SELECT id, quotationNumber FROM quotation WHERE status = 1",
    };
    let qtlistExcept = {
      query:
        "SELECT * FROM quotation WHERE status = 1 AND conversionStatus is null AND id NOT IN (SELECT quotationId FROM poAcceptance) ORDER BY id DESC",
    };
    axiosWithToken
      .post(url + `dynamic`, params.id == 0 ? qtlistExcept : qtlistAll)
      .then((res) =>  setquotationList([
      { id: 0, quotationNumber: "Verbal" }, // custom option
      ...res.data,
    ]))
      .catch((err) => console.error(err));
  };

  const fetchpoAcceptanceDetails = async () => {
    try {
      const query = `select * from poAcceptance where id = ${params.id}`;
      const [poAcceptance] = await fetchQuery(query);
      setInputStates(poAcceptance);

      let dataObject = poAcceptance;
      // Update only the required fields in the state
      updateInvoiceObject((prevState) => ({
        ...prevState,
        discount: dataObject?.discount,
        gstType: dataObject?.gstType,
        GSTPercentage: dataObject?.gstPercentage,
      }));
      let newData = {
        ...poAacceptanceData,
        ...dataObject,
      };
      dataObject && createPoAacceptance(newData);
      // let allProducts = [];
      // let sqlQuery = {
      //   query: `SELECT * FROM productDetails WHERE type = 3 AND referenceId = ${params?.id}`,
      // };

      // const response = await axiosWithToken.post(
      //   BASE_URL + `dynamic`,
      //   sqlQuery
      // );
      // allProducts = response.data;

      // const mergedProducts = Object.values(
      //   allProducts.reduce((acc, obj) => {
      //     const key = obj.rate + "_" + obj.equipmentId;
      //     if (acc[key]) {
      //       acc[key].quantity += obj.quantity;
      //     } else {
      //       acc[key] = { ...obj };
      //     }
      //     return acc;
      //   }, {})
      // );

      // setproductReadingRows(allProducts);
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) fetchpoAcceptanceDetails();
  }, [params]);

  var refresh = () => {
    window.location.reload(false);
  };

  const handleSubmit = async () => {
    const payload = {
      quotationDate: inputStates?.quotationDate ? moment(inputStates?.quotationDate).format("YYYY-MM-DD") : null,
      quotationId: inputStates?.quotationId || 0,
      poFileUrl: inputStates?.poFileUrl || null,
      poNumber: inputStates.poNumber,
      discount: invoiceObject.discount || null,
      poDate: moment(inputStates.poDate).format("YYYY-MM-DD"),
      amount: inputStates.amount || grandTotal,
      totalInstrumentQuantiity: totalInstrumentQuantity || 0,
    };

    const requiredKeys = [
      "equipmentId",
      "description",
      "rate",
      "quantity",
      "discount",
      "amount",
      "priceVariation",
    ];

    const sanitizeProducts = (referenceId) =>
      productReadingRows.map(({ id, ...product }) => {
        const sanitized = {};
        requiredKeys.forEach((key) => {
          sanitized[key] = product[key] ?? null;
        });
        return {
          ...sanitized,
          type: 3,
          referenceId,
        };
      });

    const url = BASE_URL;

    try {
      if (params.id != 0) {
        await axiosWithToken.patch(`${url}poAcceptance/${params.id}`, payload);
        // const deleteQuery = `DELETE FROM productDetails WHERE type = 3 AND referenceId = ${params.id}`;
        // await axiosWithToken.post(`${url}dynamic`, { query: deleteQuery });
        // const products = sanitizeProducts(params.id);
        // products.length > 0 && await axiosWithToken.post(`${url}productDetails/bulk`, products);
        toast("PO Acceptance updated successfully!");
      } else {
        const res = await axiosWithToken.post(`${url}poAcceptance`, payload);
        // const insertedID = res.data.insertId;
        // const products = sanitizeProducts(insertedID);
        // products.length > 0 && await axiosWithToken.post(`${url}productDetails/bulk`, products);
        toast("PO Acceptance created successfully!");
      }

      setTimeout(refresh, 500);
    } catch (error) {
      console.error("Error submitting PO Acceptance:", error);
    }
  };

  // const getProductList = () => {
  //   let url = BASE_URL;
  //   const payload = {
  //     query:
  //       "select cp.*, ins.subcategory from priceList as cp left join inspectionItems as ins on cp.serviceTypeId=ins.id;",
  //   };
  //   axiosWithToken
  //     .post(url + "dynamic", payload)
  //     .then((res) => {
  //       let productsArray = [];
  //       res.data.map((product) => {
  //         productsArray.push({
  //           id: product.id,
  //           name: product.subcategory,
  //           rate: product.rate,
  //           key: product.id,
  //           serviceTypeId: product.serviceTypeId,
  //           priceVariation: product.priceVariation ? JSON.parse(product.priceVariation) : [],
  //         });
  //       });
  //       setProductArray(productsArray);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };

  // const updateQuoObject = (key, value, q) => {
  //   let newQuoObject = {
  //     ...invoiceObject,
  //   };
  //   newQuoObject[key] = value;
  //   updateInvoiceObject({ ...newQuoObject });
  // };

  const fetchQutationDetails = (inpt) => {
    let url = BASE_URL;
    let query = {
      query: `SELECT qt.id AS qt_id, qt.gstType AS qt_gstType, qt.quotationNumber AS qt_quotationNumber, qt.enquiryReference AS qt_enquiryReference, qt.date AS qt_date,qt.totalAmount AS qt_totalAmount, qt.address AS qt_address, qt.subject AS qt_subject, qt.termsConditions AS qt_termsConditions, qt.discount AS qt_discount, qt.quotationValidity AS qt_quotationValidity, qt.projectContext AS qt_projectContext, qt.scopeservices AS qt_scopeservices, qt.clientId AS qt_clientId FROM quotation qt WHERE qt.id = ${inputStates?.quotationId};`,
    };
    axiosWithToken
      .post(url + "dynamic", query)
      .then(async (res) => {
        let quotationData = res.data[0];
        let newData = {
          ...invoiceObject,
          id: quotationData?.qt_id,
          totalAmount: quotationData?.qt_totalAmount || "",
          clientId: quotationData?.qt_clientId || "",
          quotationNumber: quotationData?.qt_quotationNumber || "",
          enquiryReference: quotationData?.qt_enquiryReference || "",
          address: quotationData?.qt_address,
          termsConditions: quotationData?.qt_termsConditions || "",
          scopeservices: quotationData?.qt_scopeservices || "",
          discount: quotationData?.qt_discount || "",
        };
        // updateInputObject("amount", quotationData?.qt_totalAmount || "");
        updateInputObject("quotationDate", quotationData?.qt_date || "");

        createPoAacceptance((prevState) => ({
          ...prevState,
          discount: quotationData?.qt_discount || "",
        }));
        quotationData && updateInvoiceObject(newData);
        quotationData && setGrandTotal(quotationData?.qt_totalAmount);

        if (params.id == 0) {
          let allProducts = [];
          let sqlQuery = {
            query: `SELECT pd.*, ii.subcategory AS name FROM productDetails pd LEFT JOIN inspectionItems ii ON pd.equipmentId = ii.id WHERE pd.type = 1 AND pd.referenceId = ${newData?.id}`,
          };
          const response = await axiosWithToken.post(
            BASE_URL + `dynamic`,
            sqlQuery
          );
          allProducts = response.data;
          const mergedProducts = Object.values(
            allProducts.reduce((acc, obj) => {
              const key = obj.rate + "_" + obj.equipmentId;
              if (acc[key]) {
                acc[key].quantity += obj.quantity;
              } else {
                acc[key] = { ...obj };
              }
              return acc;
            }, {})
          );
          setproductReadingRows(allProducts);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    // getProductList();
    getquotationData();
  }, []);

  useEffect(() => {
    if (inputStates?.quotationId && params.id == 0 && inputStates.quotationId != 0) {
      fetchQutationDetails();
    } else {
      setproductReadingRows([]);
      createPoAacceptance({});
      // updateInputObject("quotationDate", null);
      // updateInputObject("amount", null);
    } 
  }, [inputStates?.quotationId]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Po Accptance" : `Update Po Accptance`}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />

      {/* <div>
        <ProductDetails
          productArray={productArray}
          uniqueProductsByRange={productArray}
          setproductReadingRows={setproductReadingRows}
          productReadingRows={productReadingRows}
          updateQuoObject={updateQuoObject}
          grandTotal={grandTotal}
          setGrandTotal={setGrandTotal}
          invoiceObject={invoiceObject}
          isInvoice={false}
          disabled={false}
        />
      </div> */}

      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
        <SaveAndUpdate
          id="btn-add-outline"
          label={params.id == 0 ? "Save" : "Update"}
          onClick={handleSubmit}
        />
        )}
      </div>
    </div>
  );
};

export default EditpoAcceptance;
